@if (vm$ | async; as vm) {
	<router-outlet />

	<div>
		<main>
			<div
				class="container"
				[ngClass]="{ 'container--sidenav-opened': menuOpened.sidenavOpened && !isMobile }"
			>
				<!-- BACK BUTTON -->
				<button (click)="this.location.back()" class="back-button">
					<mat-icon svgIcon="porto-bank-icons:left-arrow"></mat-icon>
					Voltar
				</button>

				<!-- HEADER -->
				<div class="container__header">
					<h1 class="title">Check-in</h1>
					<h2 class="venue-title">{{ vm.venue?.name }}</h2>
				</div>

				<!-- TABS -->
				<div class="container__tabs">
					<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 1 }">
						<span>1</span>
					</div>

					<div class="line"></div>

					<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 2 }">
						<span>2</span>
					</div>

					<div class="line"></div>

					<div class="container__tabs__tab" [ngClass]="{ active: activeTab() >= 3 }">
						<span>3</span>
					</div>
				</div>

				<!-- Loading -->
				<section style="margin-top: 32px">
					<ui-porto-bank-loading-page
						*ngIf="vm.statusAvailability === 'pending' || vm.statusConfirm === 'pending'"
					/>
				</section>

				<!-- Form -->
				<div
					class="container__form"
					*ngIf="
						(vm.statusAvailability === 'success' && vm.statusConfirm === 'idle') ||
						vm.statusConfirm === 'failure'
					"
				>
					<h3>Detalhes do check-in</h3>

					<ul>
						<!-- Nome -->
						<li>
							<p>Nome</p>

							<div class="input">
								<span>{{ vm.client?.fullName }}</span>
							</div>
						</li>

						<!-- Data -->
						<li>
							<p>Data</p>

							<div class="input-date input">
								<mat-icon svgIcon="porto-bank-icons:calendar"></mat-icon>
								<span>{{ checkinDate.today | date: 'dd/MM/yyyy' }}</span>
							</div>
						</li>

						<!-- Número de pessoas -->
						<li>
							<p>Número de pessoas</p>
							<!-- Remover após campanha The Taste -->
							@if (isFixedPartySize) {
								<div class="input">
									<span>1 pessoa</span>
								</div>
							} @else {
								<div>
									<mat-select
										[(ngModel)]="partysize"
										class="input-select input"
										panelClass="custom-select-panel"
									>
										<mat-option
											*ngFor="let value of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
											[value]="partysize"
										>
											{{ value }} {{ value === 1 ? 'pessoa' : 'pessoas' }}
										</mat-option>
									</mat-select>
								</div>
							}
						</li>

						<!-- Confirmação -->
						<li>
							<div class="confirm-table">
								<label class="confirm-table__text" for="slider">
									Confirmo que estou no restaurante.
								</label>

								<div class="confirm__box">
									<label class="switch" for="slider">
										<input
											type="checkbox"
											id="slider"
											[checked]="confirm()"
											(change)="handleConfirmChange($event)"
										/>
										<span class="slider"></span>
									</label>
								</div>
							</div>
						</li>

						<div style="height: 1px; width: 100%; background-color: #e0e0e0"></div>

						<!-- Termos e condições -->
						<ui-porto-bank-confirm-slider
							(checkValueChange)="toggleTermsAndConditions($event)"
							*ngIf="showTerms()"
						>
							<p>
								Li e aceito os
								<span
									routerLink="/termos-de-uso"
									style="text-decoration: underline; color: var(--content-primary)"
								>
									termos e condições
								</span>
								para utilizar benefício.
							</p>
						</ui-porto-bank-confirm-slider>

						<!-- Confirm button -->
						<li>
							<button
								mat-button
								class="submit-button"
								[style.background-color]="
									isDisabled()
										? 'var(--background-button-disabled)'
										: 'var(--background-button-primary)'
								"
								[disabled]="isDisabled()"
								(click)="confirmCheckin()"
							>
								Confirmar
							</button>
						</li>
					</ul>
				</div>

				<ui-porto-bank-order-success
					*ngIf="vm.statusConfirm === 'success' && vm.venue && vm.client"
					type="checkin"
					[partySize]="partysize()"
					[venue]="vm.venue"
					[client]="vm.client"
					[orderDate]="checkinDate.today"
					[reservationTime]="checkinDate.time"
					[benefit]="vm.venue.benefits"
					(ok)="okClick()"
				/>
			</div>

			<div style="height: 120px; width: 100%"></div>
		</main>
	</div>
}
